import {ActionTree, MutationTree, GetterTree} from 'vuex'
import {RootState} from '@/store/types'
import api from "@/service/api";

export interface State {
    products: any,
    product: any,
    loading: boolean,
    thematics: any[],
    exportLink: string,
    // loading: boolean,
}

const defaultState: State = {
    products: null,
    product: {
        title: '',
        vendorCode: '',
        description: '',
        promo: [],
        characters: []
    },
    loading: false,
    thematics: [],
    exportLink: '',
    // loading: false,
};

const getters: GetterTree<State, RootState> = {
    products: (state: State) => state.products,
    product: (state: State) => state.product,
    loading: (state: State) => state.loading,
    thematics: (state: State) => state.thematics,
    exportLink: (state: State) => state.exportLink,
    // loading: (state: State) => state.loading,
}

const mutations: MutationTree<State> = {
    spreadNewProductList(state: State, payload: any) {
        state.products = [...payload, ...state.products]
    },
    setNewProduct(state: State, payload: any) {
        state.products.unshift(payload)
    },
    setProducts(state: State, payload: any[]) {
        state.products = payload
    },
    setProduct(state: State, payload: any[]) {
        state.product = payload
    },
    deleteProduct(state: State, payload: any) {
        state.products = state.products.filter((product: any) => product._id != payload.productId)
    },
    changeProduct(state: State, payload: any) {
        state.products = state.products.map((product: any) => {
            if (product._id == payload._id) {
                payload.showProduct = product.showProduct
                return payload
            } else {
                return product
            }
        })
    },
    changeProductShow(state: State, payload: any) {
        state.products = state.products.map((product: any) => {
            if (product._id == payload._id) {
                return payload
            } else {
                return product
            }
        })
    },
    setLoading(state: State, payload: boolean) {
        state.loading = payload
    },
    setThematics(state: State, payload: any[]) {
        state.thematics = payload
    },
    setExportLink(state: State, payload: any) {
        state.exportLink = payload.link
    }
}

const actions: ActionTree<State, RootState> = {
    async loadProductsFromServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getProducts', payload)
            const thematics = await api.go('getThematics', {params: payload.params})
            if (data.error) {
                throw (data.error)
            }
            commit('setProducts', data.data.products)
            commit('setThematics', thematics.data.data)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async getProduct({commit, state}, payload: any) {
        try {
            commit('setLoading', true)
            const {data} = await api.go('getProduct', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            if (!data.data.product.promo.length) {
                data.data.product.promo.push({
                    "title": "Ссылка",
                    "value": ""
                })
            }

            commit('setProduct', data.data.product)
            commit('setLoading', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async addNewProduct({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addNewProduct', {params: payload.params, body: payload.body})
            if (data.error) {
                throw (data.error)
            }
            commit('setNewProduct', data.data.product)

        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async deleteProductFromServer({commit, state}, payload: any) {
        try {
            const {data} = await api.go('deleteProductFromServer', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('deleteProduct', payload)

        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async joinProductToShow({commit, state}, payload: any) {
        try {
            const {data} = await api.go('joinProductToShow', {params: payload})
            commit('changeProductShow', data.data.product)
            if (data.error) {
                throw (data.error)
            }

        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async editProduct({commit, state}, payload: any) {
        try {
            const {data} = await api.go('editProduct', {params: payload.params, body: payload.body})
            if (data.error) {
                throw (data.error)
            }
            commit('changeProduct', data.data.product)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async editProductShow({commit, state}, payload: any) {
        try {
            const {data} = await api.go('editProductShow', {params: payload.params, body: payload.body})
            if (data.error) {
                throw (data.error)
            }
            commit('changeProductShow', data.data.product)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async exportProducts({commit, state}, payload: any) {
        try {
            const {data} = await api.go('exportProducts', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('setExportLink', data)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    // async deleteProduct({commit, state}, payload:any) {
    //   commit('setLoadStatus', true)

    //   try {
    //     const {data} = await axios.delete('v4/show/company/products/' + payload)
    //     if (data.error) {
    //       throw (data.error)
    //     }
    //     console.log(data)
    //     commit('setDeleteProduct', payload)
    //     commit('setLoadStatus', false)

    //   } catch (e) {
    //     this.commit('alerts/setAlert', {
    //       show: true,
    //       color: 'red',
    //       messages: [e]
    //     })
    //     console.log(e.message)
    //     commit('setLoadStatus', false)
    //   }
    // },
    // async editProduct({commit, state}, payload:any) {
    //   commit('setLoadStatus', true)

    //   try {
    //     const {data} = await axios.patch('v4/show/company/products/' + payload.id, payload.params)
    //     if (data.error) {
    //       throw (data.error)
    //     }
    //     console.log(data)
    //     commit('setEditProduct', data.data)
    //     commit('setLoadStatus', false)

    //   } catch (e) {
    //     this.commit('alerts/setAlert', {
    //       show: true,
    //       color: 'red',
    //       messages: [e]
    //     })
    //     console.log(e.message)
    //     commit('setLoadStatus', false)
    //   }
    // },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
